import { useState, useEffect } from 'react';
import { _UBLSoftwareDispatcher } from '../../../../../core/services/dataBean/EntityCatalogVdos';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const EnvironmentTypeEditor = ({ idSelector, onChange, label }: Props) => {

    const entailment = useDataBean(_UBLSoftwareDispatcher);
    const [lista, setLista] = useState<any[]>([]);
    const [id, setID] = useState<number>(idSelector);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector !== id) {
            setID(idSelector);
            ////console.log(idSelector)
        }
    }, [idSelector]);

    const setValue = (e: any) => {
        const selectedID = parseInt(e);
        onChange(selectedID);
    };

    const getLista = () => {
        entailment.instance.getUBLEnvironmentTypeConstants(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);
                }
            }
        );
    };

    return (
        <>
            <label>{label ?? "Tipo de Ambiente"}</label>
            <select className="form-select" value={id} onChange={(e) => setValue(e.target.value)}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => (
                        <option key={index} value={item.DataBeanProperties.Value}>
                            {item.DataBeanProperties.Property}
                        </option>
                    ))
                }
            </select>
        </>
    );
};
